import React from 'react'
import classNames from 'classnames'
import { IconPointFilled } from '@tabler/icons-react'
import { format } from 'date-fns'
import pluralize from 'pluralize'
import { isEmpty } from 'lodash'

import { Drawer } from '@/components/drawer/Drawer'
import { Button } from '@/components/buttons/Button'
import { dateFormat, MAX_INLINE_CHARS, MAX_INLINE_COMMENTS } from '@/utils/constants'
import { CommentEditorContainer } from '@/views/Playlists/components/CommentEditorContainer'

export const CallComments = ({
  comments = [],
  callId,
  recordType,
  messageId,
  context = 'callSearch',
  title,
}) => {
  const inlineComments = comments.slice(0, MAX_INLINE_COMMENTS)
  const hasComments = !isEmpty(comments)

  const drawerTitle =
    title || (recordType === 'email' ? `Email Comments: ${messageId}` : `Call Comments: ${callId}`)

  const renderInlineComment = (comment) => {
    const isTruncated = comment.note_text.length > MAX_INLINE_CHARS
    const displayText = isTruncated
      ? `${comment.note_text.slice(0, MAX_INLINE_CHARS)}...`
      : comment.note_text

    return (
      <div key={comment.id} className="call-comment" data-testid={`inline-comment-${comment.id}`}>
        <div className="flex-align-center small-gap">
          <div className="bold">{comment.author}</div>
          <IconPointFilled size={16} className="light-muted-text" />
          <div className="muted-text">{format(new Date(comment.created_at), dateFormat.long)}</div>
        </div>
        <div>{displayText}</div>
      </div>
    )
  }

  return (
    <>
      {hasComments && (
        <div data-testid="inline-comments-section">{inlineComments.map(renderInlineComment)}</div>
      )}
      <Drawer
        title={drawerTitle}
        trigger={(handleOpen) => (
          <div className={classNames({ mt: hasComments })}>
            <Button xs onClick={handleOpen} data-testid="drawer-trigger-button">
              {hasComments ? `View ${pluralize('Comment', comments.length, true)}` : 'Add a note'}
            </Button>
          </div>
        )}
      >
        <CommentEditorContainer callId={callId} context={context} />
      </Drawer>
    </>
  )
}
